import { ExitBtn } from "components/atoms";
import React, { FC, useEffect, useState } from "react";
import styles from "./Meta.module.css";
import { TContactUsItemProps } from "types/ContactUs";
import Modal from "react-modal";
import { TContactItems } from "components/organisms";
import { ContactModalCard } from "components/organisms/ContactUsSection/components/ContactModalCard";
import classNames from "classnames";
import { ReactModalStyles } from "components";

type TAurthorBylineProps = {
    Authors: TContactUsItemProps[],
}

export const AuthorByline: FC<TAurthorBylineProps> = ({
    Authors,
}) => {
    /* Component State */
    const [showModal, setShowModal] = useState<boolean>(false);
    const [activeCard, setActiveCard] = useState<TContactItems | null>(null);

    /* Trigger Modal Listener */
    useEffect(() => {
        if (activeCard) {
            setShowModal(true);
            document.getElementById("main-navigation")?.classList.remove("active");
            document.querySelector("body").classList.add("no-scroll");
        }

    }, [activeCard]);

    /* Component Fn's */
    const handleClose = () => {
        setActiveCard(null);
        setShowModal(false);
        document.querySelector("body").classList.remove("no-scroll");
    };


    /* Article content section | AUTHOR BYLINE */
    const authors = Authors.map((a, i) => {
        const idx = i + 1;
        const addComma = idx < Authors.length && idx < Authors.length - 1 ? true : false;
        const addAnd = idx < Authors.length && idx === Authors.length - 1 ? true : false;
        const name = (
            <span key={`${i}-${a.Firstname}-${a.Surname}-author-byline`}>
                <button
                    className="author-byline"
                    onClick={() => setActiveCard(a)}>{a.Firstname} {a.Surname}</button>
                {addComma && <span className="author-byline">, </span>}
                {addAnd && <span className="author-byline"> and </span>}
            </span>
        );

        return name;
    });


    return (
        <>
            {/* Authors */}
            {Boolean(authors) &&
                <div className="mb-20">
                    <div className={styles.content}>
                        {authors && <span className="author-byline">By </span>}{authors && authors}
                    </div>
                </div>
            }

            {/* Modal */}
            <Modal
                style={{...ReactModalStyles}}
                isOpen={showModal}
                className="Modal"
                onRequestClose={() => handleClose()}
                shouldCloseOnOverlayClick={true}
            >
                {activeCard && <div className={classNames(styles.modalContainer)}>
                    <ExitBtn style={{ top: '20px', right: '20px' }} handleIsOpenChange={() => handleClose()} />
                    <ContactModalCard activeCard={activeCard} />
                </div>}
            </Modal>
        </>
    );
}